export default {
  allSites: 'All sites',
  site: 'Site',
  radius: 'radius {meters} m',
  polygon: 'polygon · {count} corners',
  polygonShort: 'polygon ({count})',
  geofencePolygon: '{count}-corner polygon, {meters} m wake-up circle',
  inactive: 'Inactive',
  active: 'Active',
  editSite: 'Edit site',
  recalculateSessions: 'Recalculate sessions',
  deleteSite: 'Delete site',
  onSiteNow: 'On site now',
  nobodyOnSiteTitle: 'Nobody on site',
  nobodyOnSiteMessage: 'Paired phones inside the geofence will appear here within a few minutes of arriving.',
  colEmployeeNumber: 'Employee #',
  colEntered: 'Entered',
  colDuration: 'Duration',
  colLastHeard: 'Last heard',
  colEmployee: 'Employee',
  colExited: 'Exited',
  geofence: 'Geofence',
  geofenceValue: '{meters} m radius',
  centre: 'Centre',
  timeZone: 'Time zone',
  temperature: 'Temperature',
  temperatureSensor: 'Temperature ({sensor})',
  temperatureValue: '{temp} °C',
  humidityValue: '{percent}% RH',
  sessions: 'Sessions',
  inRange: '{count} in range',
  noSessionsTitle: 'No sessions in this range',
  noSessionsMessage: 'Try widening the date range, or check that phones on this site are paired and syncing.',
  stillOnSite: 'Still on site',
  closed: 'Closed',
  recalculateMessage: 'This rebuilds attendance sessions for this site from the raw presence events. It may take a moment.',
  recalculate: 'Recalculate',
  sessionsRecalculated: 'Sessions recalculated.',
  deleteMessage: '"{name}" will stop appearing to devices and site managers. Attendance history is kept.',
  siteDeleted: 'Site deleted.',
  tabOverview: 'Overview',
  tabFiles: 'Files',
  tabPhotos: 'Photos',
  filesTitle: 'Files',
  documentOne: '{count} document',
  documentOther: '{count} documents',
  uploadFile: 'Upload file',
  noFilesTitle: 'No files yet',
  noFilesMessage: 'Keep site plans, SWMS, permits and induction packs with the site so managers can find them.',
  colFile: 'File',
  colUploadedBy: 'Uploaded by',
  colAdded: 'Added',
  downloadFile: 'Download {name}',
  deleteFileLabel: 'Delete {name}',
  deleteFileTitle: 'Delete this file?',
  deleteFileMessage: '{name} will be permanently removed.',
  fileDeleted: 'File deleted.',
  chooseFile: 'Choose a file to upload.',
  fileUploaded: 'File uploaded.',
  uploadFileDescription: 'PDF, image, Office document, drawing, zip or text, up to 10 MB.',
  fileDescription: 'Description',
  fileDescriptionHint: 'Optional, e.g. the revision or what it covers.',
  uploading: 'Uploading…',
  upload: 'Upload',
  photosTitle: 'Photos',
  photoCountOne: '{count} photo',
  photoCountOther: '{count} photos',
  choosePhotos: 'Choose JPEG, PNG or WebP photos.',
  photoAdded: 'Photo added.',
  photosAdded: '{count} photos added.',
  photoFailedOne: "{count} photo couldn't be read. Use JPEG, PNG or WebP.",
  photoFailedOther: "{count} photos couldn't be read. Use JPEG, PNG or WebP.",
  uploadingProgress: 'Uploading {done} of {total}…',
  addPhotos: 'Add photos',
  noPhotosTitle: 'No photos yet',
  noPhotosMessage: 'Record site progress, access points and hazards. Drag photos here or add them from your computer.',
  photo: 'Photo',
  photoPosition: '{position} of {total}',
  previousPhoto: 'Previous photo',
  nextPhoto: 'Next photo',
  captionSaved: 'Caption saved.',
  caption: 'Caption',
  addCaption: 'Add a caption',
  deletePhotoConfirm: 'Delete this photo?',
  photoDeleted: 'Photo deleted.',
  deletePhoto: 'Delete photo',
  download: 'Download',
  tabContacts: 'Contacts',
  tabJobs: 'Jobs',
  tabNotifications: 'Notifications',
  categoryPlan: 'Plan',
  categorySwms: 'SWMS',
  categoryPermit: 'Permit',
  categoryInduction: 'Induction',
  categoryOther: 'Other',
  colType: 'Type',
  fileType: 'Type',
  fileTypeHint: 'Where it shows up when you filter the list.',
  filterAllTypes: 'All',
  noFilesOfTypeTitle: 'Nothing filed as {type}',
  noFilesOfTypeMessage: 'Upload a file and choose this type, or pick another filter.',
  changeFileType: 'Change type of {name}',
  contactsTitle: 'Contacts',
  contactOne: '{count} contact',
  contactOther: '{count} contacts',
  addContact: 'Add contact',
  editContact: 'Edit contact',
  noContactsTitle: 'No contacts yet',
  noContactsMessage: "Keep the people to call about this site here: the client's representative, the gate, the safety officer.",
  contactDetailsDescription: 'Reference details only. Contacts are not employees and cannot sign in.',
  contactName: 'Name',
  contactRole: 'Role',
  contactRoleHint: 'For example Site supervisor or Client representative.',
  contactOrganisation: 'Company',
  contactPhone: 'Phone',
  contactEmail: 'Email',
  contactNotes: 'Notes',
  contactNotesHint: 'Gate codes, best times to call, anything the crew should know.',
  contactPrimary: 'First person to call',
  contactPrimaryBadge: 'Primary',
  contactSaved: 'Contact saved.',
  contactAdded: 'Contact added.',
  contactDeleted: 'Contact deleted.',
  deleteContactLabel: 'Delete {name}',
  editContactLabel: 'Edit {name}',
  deleteContactTitle: 'Delete this contact?',
  deleteContactMessage: '{name} will be removed from this site and from any notifications they were chosen for.',
  colContact: 'Contact',
  colDetails: 'Details',
  callContact: 'Call {name}',
  jobsTitle: 'Jobs',
  jobsUpcoming: 'Upcoming',
  jobsPast: 'Past',
  jobsRangeUpcoming: 'Next {days} days',
  jobsRangePast: 'Last {days} days',
  newJob: 'New job',
  noJobsUpcomingTitle: 'No upcoming jobs',
  noJobsUpcomingMessage: 'Jobs at this site show up here with their checklists. Create one to roster a crew and give them a to-do list.',
  noJobsPastTitle: 'No past jobs',
  noJobsPastMessage: 'Jobs that ended in the last two months appear here.',
  colJob: 'Job',
  colWhen: 'When',
  colCrew: 'Crew',
  colChecklist: 'Checklist',
  jobDraft: 'Draft',
  jobPublished: 'Published',
  crewOne: '{count} assigned',
  crewOther: '{count} assigned',
  noCrewYet: 'Nobody assigned',
  noChecklist: 'No checklist',
  showChecklist: 'Show checklist for {title}',
  hideChecklist: 'Hide checklist for {title}',
  openJob: 'Open {title}',
  taskCompletedBy: 'Done by {name}',
  taskToDo: 'To do',
  notificationsTitle: 'Who gets notified',
  notificationsDescription: 'Each alert already goes to the people it always has. Add anyone else who should hear about it for this site.',
  notificationsAdminOnly: 'Only an admin can change who is notified.',
  eventEmergency: 'Emergency alert',
  eventEmergencyAlready: "Someone presses the emergency button here. Already emailed: every admin, this site's managers and the employee's manager.",
  eventJobResponse: 'Job accepted or declined',
  eventJobResponseAlready: "An employee answers a job here. Already emailed: whoever created the job and the employee's manager.",
  eventMissedCheckIn: 'Missed check-in',
  eventMissedCheckInAlready: "A rostered employee still hasn't arrived after their reminder. Already emailed: the employee's manager.",
  notifyStaff: 'Staff',
  notifyStaffNone: 'No staff with an email address can see this site.',
  notifyContacts: 'Site contacts',
  notifyContactsHint: 'Contacts are only ever emailed about emergencies.',
  notifyNoContacts: 'Add contacts with an email address on the Contacts tab to notify them about emergencies.',
  notifyNoEmail: 'No email address',
  notifyRoleAdmin: 'Admin',
  notifyRoleManager: 'Site manager',
  notifySaved: 'Notification settings saved.',
}
